import { useEffect } from 'react';
import { useMatch, NavigateOptions, useNavigate, type AnyRoute } from '@frontend/weave-router';
import { PaymentsNavAlerts } from '../../utils/helpers';
import { getValidPrevPaymentsPath } from '../../utils/unique-link';
import { usePaymentAlerts } from './use-payment-alerts';

interface UseNavigateWithAlertParams {
  enable?: boolean;
  key: PaymentsNavAlerts;
  to?: NavigateOptions;
  toPrevRoute?: boolean;
}

export const usePaymentNavigateWithAlert = ({
  enable = false,
  key,
  to: toFromParams,
  toPrevRoute = false,
}: UseNavigateWithAlertParams) => {
  const navigate = useNavigate();
  const match = useMatch({ strict: false });
  const { showPaymentAlert } = usePaymentAlerts();
  const prevRoute = getValidPrevPaymentsPath(match.fullPath);

  const navigateWithAlert = (toOverride?: typeof toFromParams) => {
    showPaymentAlert(key);
    if (toOverride) {
      navigate(toOverride);
    } else if (toFromParams) {
      navigate(toFromParams);
    }
  };

  useEffect(() => {
    if (enable && (toPrevRoute || toFromParams))
      navigateWithAlert(toPrevRoute ? { to: prevRoute as AnyRoute } : toFromParams);
  }, [enable, toPrevRoute]);

  return { prevRoute, navigateWithAlert };
};
